/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type OneOnOneAutopilotCanAutopilotQueryVariables = {
    orgRelayId: string;
    userCalendarIds: Array<string>;
    externalEventIds: Array<string>;
};
export type OneOnOneAutopilotCanAutopilotQueryResponse = {
    readonly org: {
        readonly canScheduleResponse?: ({
            readonly __typename: "CanScheduleResponseList";
            readonly list: ReadonlyArray<{
                readonly externalEventId: string;
                readonly canAutopilot: boolean;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
    } | null;
};
export type OneOnOneAutopilotCanAutopilotQuery = {
    readonly response: OneOnOneAutopilotCanAutopilotQueryResponse;
    readonly variables: OneOnOneAutopilotCanAutopilotQueryVariables;
};



/*
query OneOnOneAutopilotCanAutopilotQuery(
  $orgRelayId: ID!
  $userCalendarIds: [String!]!
  $externalEventIds: [String!]!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {
        __typename
        ... on CanScheduleResponseList {
          list {
            externalEventId
            canAutopilot
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalEventIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userCalendarIds"
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "calendarIds",
                        "variableName": "userCalendarIds"
                    },
                    {
                        "kind": "Variable",
                        "name": "externalEventIds",
                        "variableName": "externalEventIds"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "canScheduleResponse",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CanScheduleResponse",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalEventId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "canAutopilot",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "CanScheduleResponseList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "OneOnOneAutopilotCanAutopilotQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "OneOnOneAutopilotCanAutopilotQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        (v5 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "1f15f80c1695dc1054437e2753d9b76d",
            "id": null,
            "metadata": {},
            "name": "OneOnOneAutopilotCanAutopilotQuery",
            "operationKind": "query",
            "text": "query OneOnOneAutopilotCanAutopilotQuery(\n  $orgRelayId: ID!\n  $userCalendarIds: [String!]!\n  $externalEventIds: [String!]!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {\n        __typename\n        ... on CanScheduleResponseList {\n          list {\n            externalEventId\n            canAutopilot\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '83e0c5a95988e9b7ca6f4dea37232298';
export default node;
